const robotsSelector = 'meta[name="robots"]';

export const replaceRobotsMeta = (content) => {
  const metas = Array.from(document.head.querySelectorAll(robotsSelector));
  const primary = metas.find((meta) => meta.dataset.robotsManaged === "true") || metas[0];
  const robots = primary || document.createElement("meta");
  if (!robots.parentNode) {
    robots.name = "robots";
    document.head.appendChild(robots);
  }
  robots.dataset.robotsManaged = "true";
  robots.content = content;
  metas.filter((meta) => meta !== robots).forEach((meta) => meta.remove());
  return robots;
};